import React from "react";

const WhoScript = () => {
  return (
    <div>
      <div>
        <h3 className="text-7xl font-FreckleFace text-white hover:text-8xl p-5">
          Who's this guy?
        </h3>
      </div>
      <div className="p-5 text-2xl font-Oswald">
        <p className="p-2">
          <b className="text-3xl underline">Phil</b> hails from the vibrant
          comedy scene of Washington DC. His journey began in the local comedy
          clubs of the DMV. He has been making audiences roar with laughter for
          over eight years. His comedy career has spanned across the nation. His
          comedic prowess has led him to perform at some of the most prestigious
          venues across the country from the New York Comedy Club to the
          Broadway Comedy Club, and even the West Side Comedy Club in the heart
          of NYC. He has left audiences roaring with laughter. And let's not
          forget about his escapades in LA at The Compton Hotel and Casino and
          the Chateau Comedy Club, where he probably made more friends than the
          actual headliners in Las Vegas. Phillip has graced the stage at
          Wiseguys in Las Vegas. He certainly has a talent for winning over
          crowds. His dynamic energy and his unique comedic style have
          captivated audiences, leaving them in stitches and wanting more.
        </p>
        <p className="p-2">
          He has been described as a delightful blend of the legendary Red Fox
          and the iconic Rodney Dangerfield. Phillip is known for his sharp,
          interactive one-liners that resonate with crowds of all backgrounds.
          He brings a fresh perspective to comedy, tackling everyday life’s
          absurdities with wit and charm.
        </p>
        <p className="p-2">
          Beyond the mic, Phillip is a passionate comedy show producer,
          spearheading his monthly BARBERSHOP shows. These events are more than
          just a night of laughs; they serve as a platform for community
          activism, addressing pressing issues such as gun violence, Homeless,
          Drug addiction and helping returning prisoners reintegrate into
          society and fundraising for local organizations through the power of
          laughter. His aim is to uplift and unite the community, proving that
          humor can be a catalyst for positive change.
        </p>
        <p className="p-2">
          <b className="text-3xl underline">Phil</b> is on this comedic journey,
          where laughter meets purpose, and every punchline brings us one step
          closer to understanding and healing together.
        </p>
      </div>
      <div>
        <h3 className="text-2xl px-8">[Applause]</h3>
      </div>
    </div>
  );
};

export default WhoScript;
